module.exports = __webpack_public_path__ + "static/img/va-a-semu.1df37c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/va-a-semu.jpg
// module id = GxOA
// module chunks = 0